// Surum bilgisine tek giris noktasi.
// version.json prestart/prebuild ile uretilir; yoksa package.json'a duser.
let info;
try {
  // eslint-disable-next-line global-require, import/no-unresolved
  info = require("./version.json");
} catch {
  info = {
    version: process.env.REACT_APP_VERSION || "0.0.0",
    commit: null,
    builtAt: null,
    env: process.env.NODE_ENV || "development",
  };
}

export const APP_VERSION = info.version;
export const APP_COMMIT = info.commit;
export const APP_BUILT_AT = info.builtAt;
export const APP_ENV = info.env;
export default info;
